export default {
    url: '/survey',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManageSurveys();
        }
    },
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/survey/index.js